import React, { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import SessionTimeline from "../components/sessionRequest/SessionTimeLine";
import SessionSummary from "../components/sessionRequest/SessionSummary";
import { Layout } from "../components/Layout";

const SessionRequest: React.FC = () => {
  const { notaryId } = useParams<{ notaryId: string }>();
  const navigate = useNavigate();
  const [activeSession, setActiveSession] = useState<any>(null);
  const isMounted = useRef(true);

  const handleSessionSelect = (session: any) => {
    if (isMounted.current) {
      setActiveSession(session);
      navigate(`/notary/${session.id}`, { replace: true });
    }
  };

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <Layout>
      <SessionTimelineContainer>
        <SessionTimeline
          onSessionSelect={handleSessionSelect}
          activeSessionId={notaryId}
        />
      </SessionTimelineContainer>
      <SessionSummaryContainer>
        <SessionSummary
          session={activeSession}
          activeSessionId={notaryId}
        />
      </SessionSummaryContainer>
    </Layout>
  );
};

export default SessionRequest;

const SessionTimelineContainer = styled.div`
  flex: 1;
  max-width: 25%;
  height: 100%;
  // background: #F9F9F9;
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none; /* WebKit */
  }
`;

const SessionSummaryContainer = styled.div`
  flex: 3;
  background: #f9f9f9;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  @media (max-width: 768px) {
    max-width: 100%;
    flex: none;
    width: 100%;
  }
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none; /* WebKit */
  }
`;
